var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9C5.88667 8.99995 6.74821 8.70542 7.44935 8.16268C8.15049 7.61993 8.65152 6.85969 8.87378 6.00133M5 9C4.11334 8.99995 3.2518 8.70542 2.55066 8.16268C1.84951 7.61993 1.34848 6.85969 1.12622 6.00133M5 9C6.10445 9 7 7.20889 7 5C7 2.79111 6.10445 1 5 1M5 9C3.89556 9 3 7.20889 3 5C3 2.79111 3.89556 1 5 1M8.87378 6.00133C8.956 5.68133 9 5.34578 9 5C9.0011 4.31205 8.82394 3.63555 8.48578 3.03644M8.87378 6.00133C7.68852 6.65839 6.3552 7.00213 5 7C3.59467 7 2.27422 6.63778 1.12622 6.00133M1.12622 6.00133C1.04211 5.67421 0.999701 5.33776 1 5C1 4.28667 1.18667 3.61644 1.51422 3.03644M5 1C5.70944 0.999704 6.40619 1.18816 7.01875 1.54603C7.63132 1.9039 8.13764 2.4183 8.48578 3.03644M5 1C4.29056 0.999704 3.59381 1.18816 2.98125 1.54603C2.36869 1.9039 1.86236 2.4183 1.51422 3.03644M8.48578 3.03644C7.51808 3.87464 6.28024 4.33518 5 4.33333C3.66756 4.33333 2.44889 3.84444 1.51422 3.03644",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 9L9 1",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globeIcon.d042128cbad117801b1c785c8a950d37.svg";
export { ForwardRef as ReactComponent };